<template>
  <div
    id="vue-mobile-menu"
    :class="env == 'development' ? 'phm' : 'phm hide'"
  >
    <Menu :items="menuItems" />
  </div>
</template>

<script>
import Menu from "./components/Menu.vue";
import axios from "axios";

export default {
  name: "App",
  components: {
    Menu,
  },
  data() {
    return {
      menuItems:   [],
      env: process.env.NODE_ENV,
    };
  },
  computed: {
    language() {
      let lang = this.isTranslated(window.location.pathname);
      const validLanguages = [ '/es', '/zh', '/ar', '/ht', '/fr', '/sw', '/pt', '/ru', '/vi' ];
      if (validLanguages.includes(lang)) {
        return lang.substring(1); 
      } 
      return 'en'; 
    },
  },
  created () {
    let vm = this;
    vm.init();
  },
  methods: {
    async init() {
      let vm = this;

      const languageCode = vm.language; 
      const url = process.env.VUE_APP_BUCKET_URL + `${languageCode}/phila_service_menu.json`;

      try {
        const response = await axios.get(url);
        let modifiedJson = vm.insertMenuDescription(languageCode, response.data);
        vm.menuItems = modifiedJson;
      } catch (e) {
        window.console.log(e);
      }
    },

    isTranslated(path) {
      let splitPath = path.split("/");
      const langList = [ 'zh', 'es','ar', 'fr', 'ru', 'ms', 'hi', 'pt', 'bn', 'id', 'sw', 'ja', 'de', 'ko', 'it', 'fa', 'tr', 'nl', 'te', 'vi', 'ht' ];
      for (let i = 0; i < splitPath.length; i++) {
        if (langList.indexOf(splitPath[i]) > -1) {
          return '/'+splitPath[i];
        }
      }
      return null;
    },

    insertMenuDescription(langCode, mobile_menu) {
      var langJson = require(`./assets/descriptions/${langCode}/nav_bar_desc.json`);
      mobile_menu.forEach(item => {
        const description = langJson[item.post_name];
        if (description) {
          item.post_description = description;
        }
      });
      return mobile_menu;
    },
  },
};
</script>
